import { render, staticRenderFns } from "./edit-brand.vue?vue&type=template&id=5711bdea&scoped=true&"
import script from "./edit-brand.vue?vue&type=script&lang=js&"
export * from "./edit-brand.vue?vue&type=script&lang=js&"
import style0 from "./edit-brand.vue?vue&type=style&index=0&id=5711bdea&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5711bdea",
  null
  
)

export default component.exports